module.exports = __webpack_public_path__ + "img/logo-viajar-simples.35f0088c.png";